import { createTheme } from '@mui/material/styles';
import { color, typographyLineHeight, typographySize } from './Styles';

const commonSettings = {
    typography: {
        fontFamily: 'Archivo, sans-serif',
    },
    components: {
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    fontSize: '1rem',
                    fontWeight: 700,
                },
            },
        },
        // MuiOutlinedInput: {
        //     styleOverrides: {
        //         root: {
        //             paddingRight: '0',
        //         },
        //         notchedOutline: {
        //             borderColor: color.border,
        //         },
        //     },
        // },
        MuiCheckbox: {
            styleOverrides: {
                indeterminate: {
                    color: 'red',
                },
            },
        },
        MuiButtonBase: {
            defaultProps: {
                disableRipple: true,
            },
        },
        MuiDialog: {
            styleOverrides: {
                paper: {
                    borderRadius: '0.5rem',
                },
            },
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    fontSize: typographySize.font_sm,
                    lineHeight: typographyLineHeight.font_xs,
                },
            },
            defaultProps: {
                enterDelay: 800,
                leaveDelay: 200,
                enterNextDelay: 400,
            },
        },
        MuiRadio: {
            defaultProps: {
                disableRipple: true,
            },
        },
    },
};

export const muiLightTheme = createTheme({
    ...commonSettings,
    palette: {
        mode: 'light',
        text: {
            primary: color.primary_dark,
        },
        primary: {
            main: color.secondary,
            contrastText: color.border,
        },
        secondary: {
            main: color.tertiary,
        },
        error: {
            main: color.error,
        },
        background: {
            paper: color.bg_light,
        },
        info: {
            light: '#7676ca', // switch icon
            main: color.secondary,
            dark: color.bg_light,
            contrastText: color.bg_light,
        },
    },
    components: {
        ...commonSettings.components,

        MuiInputLabel: {
            styleOverrides: {
                root: {
                    ...commonSettings.components.MuiInputLabel.styleOverrides.root,
                    color: color.primary_dark,
                },
            },
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    ...commonSettings.components.MuiTooltip.styleOverrides.tooltip,
                    backgroundColor: color.secondary_light,
                    color: color.primary_dark,
                },
                arrow: {
                    color: color.bg_light,
                },
            },
        },
    },
});

export const muiDarkTheme = createTheme({
    ...commonSettings,
    palette: {
        mode: 'dark',
        text: {
            primary: color.bg_light,
        },
        primary: {
            main: color.accent_light,
            contrastText: color.primary_light,
        },
        secondary: {
            main: color.tertiary,
        },
        error: {
            main: color.error_light,
        },
        background: {
            paper: color.primary_dark,
        },
        info: {
            light: '#2086c4', // switch icon
            main: color.accent,
            dark: color.primary_dark,
            contrastText: color.bg_light,
        },
    },
    components: {
        ...commonSettings.components,
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    ...commonSettings.components.MuiInputLabel.styleOverrides.root,
                    color: color.bg_light,
                },
            },
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    ...commonSettings.components.MuiTooltip.styleOverrides.tooltip,
                    backgroundColor: color.primary_dark,
                },
                arrow: {
                    color: color.primary_dark,
                },
            },
        },
    },
});
